export const UMRAH_STARTING_PRICE_USD = 2275

export const UMRAH_TRUST_FACTS = Object.freeze({
  agencyCertificate: '7677',
  experienceYears: 21,
  annualPilgrims: 3500,
  totalPilgrims: 30000,
})

export const UMRAH_KEYWORD_PAGE_MAP = Object.freeze({
  home: { path: '/', primaryKeyword: 'umre turları', intent: 'genel ticari' },
  catalog: { path: '/tour/umre-turlari', primaryKeyword: 'umre fiyatları', intent: 'fiyat ve program karşılaştırma' },
  premium: { path: '/tour/5-yildizli-luks-umre-turlari', primaryKeyword: '5 yıldızlı umre turları', intent: 'premium tur' },
  vip: { path: '/tour/vip-umre-programlari', primaryKeyword: 'VIP umre turları', intent: 'kişiselleştirilmiş tur' },
  duration3: { path: '/tour/3-gunluk-umre-turlari', primaryKeyword: '3 günlük umre turları', intent: 'kişiye özel kısa program talebi' },
  duration5: { path: '/tour/5-gunluk-umre-turlari', primaryKeyword: '5 günlük umre turları', intent: 'kısa süreli tur' },
  duration7: { path: '/tour/7-gunluk-umre-turlari', primaryKeyword: '7 günlük umre turları', intent: 'süre bazlı tur' },
  duration8: { path: '/tour/8-gunluk-umre-turlari', primaryKeyword: '8 günlük umre turları', intent: 'süre bazlı tur' },
  duration10: { path: '/tour/10-gunluk-umre-turlari', primaryKeyword: '10 günlük umre turları', intent: 'süre bazlı tur' },
  duration12: { path: '/tour/12-gunluk-umre-turlari', primaryKeyword: '12 günlük umre turları', intent: 'uzun süreli tur' },
  duration13: { path: '/tour/13-gunluk-umre-turlari', primaryKeyword: '13 günlük umre turları', intent: 'uzun süreli tur' },
  duration15: { path: '/tour/15-gunluk-umre-turlari', primaryKeyword: '15 günlük umre turları', intent: 'uzun konaklamalı tur' },
  ramadan: { path: '/tour/ramazan-umre-turlari', primaryKeyword: 'Ramazan umre turları', intent: 'dönem bazlı tur' },
  semester: { path: '/tour/somestr-umre-turlari', primaryKeyword: 'sömestr umre turları', intent: 'tatil dönemi turu' },
  hotelGuide: { path: '/page/umre-otelleri-rehberi', primaryKeyword: 'umre otelleri', intent: 'otel araştırma rehberi' },
  deluxeGuide: { path: '/page/delux-umre-konsepti', primaryKeyword: 'delüks umre nedir', intent: 'bilgilendirici' },
  selectionGuide: { path: '/page/en-iyi-umre-turu-nasil-secilir', primaryKeyword: 'umre turu tavsiye', intent: 'karar ve firma karşılaştırma' },
  femaleGuidance: { path: '/page/kadin-irsad-gorevlisi', primaryKeyword: 'umrede kadın irşad görevlisi', intent: 'kadın yolcular için rehberlik kapsamı' },
  firstUmrahGuide: { path: '/page/ilk-kez-umreye-gidecekler', primaryKeyword: 'ilk kez umreye gidecekler', intent: 'ilk yolculuk ve hazırlık rehberi' },
  documentsGuide: { path: '/page/umre-icin-gerekli-belgeler', primaryKeyword: 'umre için gerekli belgeler', intent: 'evrak, vize ve sağlık hazırlığı' },
  nusukGuide: { path: '/page/nusuk-ravza-randevusu', primaryKeyword: 'Nusuk Ravza randevusu', intent: 'uygulama ve ziyaret planlama' },
  seniorGuide: { path: '/page/yaslilar-icin-umre-rehberi', primaryKeyword: 'yaşlılar için umre', intent: 'erişilebilirlik ve refakat planlama' },
  familyGuide: { path: '/page/cocukla-umre-rehberi', primaryKeyword: 'çocukla umre', intent: 'aile yolculuğu planlama' },
})

const seasonLabel = (year) => `${year}-${Number(year) + 1}`

const DURATION_KEYWORDS_TR = Object.freeze({
  3: '3 günlük umre fiyatları, kısa umre turu, hafta sonu umre programı',
  5: '5 günlük umre fiyatları, kısa süreli umre, bir haftadan kısa umre',
  7: '7 günlük umre fiyatları, umre turları 1 hafta, bir haftalık umre, kısa süreli umre programı',
  8: '8 günlük umre fiyatları, sekiz günlük umre, bir haftalık umre alternatifleri',
  10: '10 günlük umre fiyatları, Mekke Medine umre programı, orta süreli umre',
  12: '12 günlük umre fiyatları, uzun süreli umre, Mekke Medine konaklamalı umre',
  13: '13 günlük umre fiyatları, iki haftaya yakın umre, uzun süreli umre programı',
  15: '15 günlük umre fiyatları, uzun konaklamalı umre, iki haftalık umre programı',
})

const buildDurationSeoEntries = (season, locale) => {
  const isEnglish = locale === 'en'
  return Object.fromEntries(Object.keys(DURATION_KEYWORDS_TR).map((value) => {
    const days = Number(value)
    const key = `duration${days}`

    if (days === 3 && isEnglish) {
      return [key, {
        title: '3-Day Umrah Packages ' + season + ' | Private Itinerary Request',
        h1: '3-Day Umrah: Private Itinerary Options ' + season,
        description: 'There is no standard 3-day package. Our scheduled Umrah programs start from 6 days; ask us to assess a tailored short itinerary based on flights, hotels and transfers.',
        keywords: season + ' 3-day Umrah package, private Umrah itinerary, short Umrah program, tailored Umrah',
      }]
    }

    if (days === 3) {
      return [key, {
        title: '3 Günlük Umre Turları ' + season + ' | Kişiye Özel Program',
        h1: '3 Günlük Umre Turları ve Kişiye Özel Seçenekler ' + season,
        description: 'Standart 3 günlük umre turumuz yoktur. En az 6 günlük programlarımızı inceleyin veya uçuş, otel ve transfere göre kişiye özel kısa umre talep edin.',
        keywords: season + ' 3 günlük umre turları, 3 günlük umre fiyatları, kişiye özel umre, kısa umre programı',
      }]
    }

    if (isEnglish) {
      return [key, {
        title: `${days}-Day Umrah Packages ${season} | Dates & Prices`,
        h1: `${season} ${days}-Day Umrah Packages`,
        description: `Compare ${season} ${days}-day Umrah packages by departure date, Makkah and Madinah nights, named hotels, room price, flights, transfers and availability.`,
        keywords: `${season} ${days}-day Umrah packages, ${days}-day Umrah prices, short Umrah package, Makkah Madinah Umrah itinerary`,
      }]
    }

    return [key, {
      title: days === 7
        ? `7 Günlük Umre Turları ${season} | 1 Haftalık Umre`
        : `${days} Günlük Umre Turları ${season} | Tarih ve Fiyatlar`,
      h1: `${days} Günlük Umre Turları ve Fiyatları ${season}`,
      description: days === 7
        ? `${season} 7 günlük umre turları ve 1 haftalık umre seçeneklerini; tarih, Mekke-Medine otelleri, oda fiyatı, uçuş, transfer ve kontenjana göre karşılaştırın.`
        : `${season} ${days} günlük umre turlarını; kalkış tarihi, Mekke-Medine gece dağılımı, oteller, oda fiyatı, uçuş, transfer ve kontenjana göre karşılaştırın.`,
      keywords: `${season} ${days} günlük umre turları, ${DURATION_KEYWORDS_TR[days]}`,
    }]
  }))
}

export const buildUmrahSeoStrategy = (year = new Date().getFullYear(), locale = 'tr') => {
  const season = seasonLabel(year)
  const isEnglish = locale === 'en'

  if (isEnglish) {
    return {
      season,
      startingPriceLabel: 'USD 2,275',
      home: {
        title: `Umrah Packages ${season} | 21 Years of Experience | Inanc Tour`,
        h1: `${season} Umrah Packages`,
        description: `Explore ${season} 5-star Umrah packages from USD 2,275 with 21 years of experience, 3,500 pilgrims annually and 30,000+ pilgrims served. Agency certificate 7677.`,
        keywords: `${season} Umrah packages, Umrah tours, guided Umrah, Umrah travel agency, Inanc Tour`,
      },
      catalog: {
        title: `Umrah Prices ${season} | Compare Dates & Packages`,
        h1: `${season} Umrah Prices, Dates and Packages`,
        description: `Compare ${season} Umrah prices from USD 2,275 by 7 or 10-day package, departure date, hotel, room type, flight and availability.`,
        keywords: `${season} Umrah prices, Umrah dates, 7-day Umrah, 10-day Umrah, Umrah package comparison`,
      },
      premium: {
        title: `5-Star & Luxury Umrah Packages ${season} | Inanc Tour`,
        h1: `${season} 5-Star and Luxury Umrah Packages`,
        description: `Compare ${season} 5-star and luxury Umrah packages from USD 2,275 by Makkah and Madinah hotel, Haramain distance, room, flight and service scope.`,
        keywords: `${season} 5-star Umrah packages, luxury Umrah packages, premium Umrah, hotels near Haram, Makkah hotels, Madinah hotels`,
        eyebrow: 'Named hotels, Haramain distance and premium service scope',
        heading: 'Compare 5-Star and Luxury Umrah by Hotel, Location and Service',
        intro: 'A hotel’s star rating and a package’s luxury positioning are not enough on their own. Compare the exact Makkah and Madinah hotels, distance to the Haramain, room occupancy, meals, flights, transfers and guidance included in each confirmed departure.',
      },
      vip: {
        title: `VIP & Boutique Umrah Packages ${season} | Inanc Tour`,
        h1: `${season} VIP and Boutique Umrah Packages`,
        description: `Explore Inanc Tour's scheduled VIP and boutique Umrah standard: groups of 20–45, Fairmont Makkah, Turkish Airlines, high-speed rail, VIP road transport and dedicated field teams.`,
        keywords: `${season} VIP Umrah packages, boutique Umrah packages, small-group Umrah, Fairmont Makkah Umrah, Turkish Airlines Umrah, VIP transfer Umrah`,
        eyebrow: 'Boutique-level service as standard on scheduled departures',
        heading: 'VIP and Boutique Umrah Is a Defined Service Standard at Inanc Tour',
        intro: 'Our scheduled groups are planned for 20–45 guests. The whole group stays together at Fairmont in Makkah for the current season; Turkish Airlines, high-speed rail between Madinah and Makkah, VIP road transport, a guest-focused tour scholar, four local field staff and breakfast and dinner buffets are part of the service model.',
      },
      ...buildDurationSeoEntries(season, 'en'),
      ramadan: {
        title: `Ramadan Umrah Packages ${season} | Dates & Hotels`,
        h1: `${season} Ramadan Umrah Packages`,
        description: `Compare Ramadan Umrah packages by departure and return date, fasting-day itinerary, named hotels, room type, flights and current availability.`,
        keywords: `${season} Ramadan Umrah packages, Ramadan Umrah prices, last ten days Umrah, Ramadan Umrah dates`,
      },
      semester: {
        title: `School Holiday Umrah Packages ${season} | Family Programs`,
        h1: `${season} School Holiday Umrah Packages`,
        description: `Explore school holiday Umrah packages for families by confirmed dates, duration, named hotels, room arrangement, child pricing and flights.`,
        keywords: `${season} school holiday Umrah packages, family Umrah, Umrah with children, school break Umrah`,
      },
      hotelGuide: {
        title: `Umrah Hotels Guide ${season} | Makkah & Madinah`,
        h1: 'Umrah Hotels in Makkah and Madinah: Selection Guide',
        description: 'Compare Umrah hotels by exact name, Haramain distance, transport, star category, meal plan, room layout and nights in Makkah and Madinah.',
        keywords: 'Umrah hotels, Makkah Umrah hotels, Madinah Umrah hotels, hotels near Haram, hotels near Masjid an-Nabawi',
      },
      deluxeGuide: {
        title: 'What Is Deluxe Umrah? Luxury & VIP Differences | Inanc Tour',
        h1: 'What Is the Deluxe Umrah Concept?',
        description: 'Learn what deluxe Umrah means, how it differs from 5-star, luxury, VIP and boutique Umrah, and which hotel, transfer and service details to compare.',
        keywords: 'what is deluxe Umrah, deluxe Umrah concept, deluxe vs luxury Umrah, deluxe vs VIP Umrah, premium Umrah comparison',
      },
      selectionGuide: {
        title: 'How to Choose the Best Umrah Package & Company | Inanc Tour',
        h1: 'How to Choose the Best Umrah Package and Company',
        description: 'Compare Umrah companies and packages by agency authorisation, named hotels, flights, transfers, guidance, contract terms, reviews and transparent pricing.',
        keywords: 'best Umrah packages, best Umrah companies, reliable Umrah company, how to choose an Umrah package, compare Umrah companies',
      },
      femaleGuidance: {
        title: 'Female Guidance During Umrah | Inanc Tour',
        h1: 'Is a Female Guide Available During Umrah?',
        description: 'Learn when female guidance is available on Inanc Tour Umrah programs, including Rawdah visits, full-tour assignment and in-app information for women.',
        keywords: 'female Umrah guide, female religious guide Umrah, women Rawdah visit, women guidance during Umrah',
      },
      trust: [
        { value: '21 years', label: 'Umrah experience' },
        { value: '3,500', label: 'Umrah pilgrims annually' },
        { value: '30,000+', label: 'Pilgrims served' },
        { value: '7677', label: 'Agency certificate' },
      ],
    }
  }

  return {
    season,
    startingPriceLabel: '2.200 USD',
    home: {
      title: `Umre Turları, 21 Yıllık Deneyim | İnanç Tur, Vip & Lüks Hizmet ${season}`,
      h1: `${season} Umre Turları`,
      description: `İnanç Tur’un 5 yıldızlı ${season} umre turları 2.200 USD’den başlıyor. 21 yıllık deneyim, yılda 3.500 ve bugüne kadar 40.000+ umre yolcusu. TÜRSAB 7677.`,
      keywords: `${season} umre turları, umre programları, rehberli umre, umre seyahat acentası, İnanç Tur`,
    },
    catalog: {
      title: `Umre Fiyatları ${season}, 5 yıldızlı Turlar | Tarih ve Tur Karşılaştır`,
      h1: `Umre Fiyatları ${season}`,
      description: `2.200 USD’den başlayan ${season} umre fiyatlarını; 7 ve 10 günlük program, kalkış tarihi, otel, oda tipi, uçuş ve kontenjana göre karşılaştırın.`,
      keywords: `${season} umre fiyatları, umre turları, umre tarihleri, 5-6 günlük umre, 7 günlük umre, 10 günlük umre, vip umre programı karşılaştırma.`,
    },
    premium: {
      title: `5 Yıldızlı ve Lüks Umre Turları ${season} | İnanç Tur`,
      h1: `${season} 5 Yıldızlı ve Lüks Umre Turları`,
      description: `2.200 USD’den başlayan ${season} 5 yıldızlı ve lüks umre turlarını; Mekke-Medine oteli, Haremeyn mesafesi, oda, uçuş ve hizmet kapsamıyla karşılaştırın.`,
      keywords: `${season} 5 yıldızlı umre turları, lüks umre turları, premium umre, Kâbe’ye yakın otel, Mekke otelleri, Medine otelleri`,
      eyebrow: 'İsmi açıklanan oteller, Haremeyn mesafesi ve premium hizmet kapsamı',
      heading: '5 Yıldızlı ve Lüks Umreyi Otel, Konum ve Hizmete Göre Karşılaştırın',
      intro: 'Otelin yıldız sınıfı ve programın lüks olarak tanımlanması tek başına yeterli değildir. Kesinleşen her kalkışta Mekke ve Medine otellerinin tam adını, Haremeyn’e mesafeyi, oda yerleşimini, yemekleri, uçuşu, transferleri ve rehberlik kapsamını birlikte inceleyin.',
    },
    vip: {
      title: `VIP ve Butik Umre Turları ${season} | İnanç Tur`,
      h1: `${season} VIP ve Butik Umre Turları`,
      description: `${season} kesin kalkışlı VIP ve butik umre standardımızı inceleyin: 20–45 kişilik grup, Fairmont Mekke, THY, hızlı tren, VIP araçlar ve geniş saha ekibi.`,
      keywords: `${season} VIP umre turları, butik umre turları, küçük grup umre, Fairmont Mekke umre, Türk Hava Yolları umre, VIP transferli umre`,
      eyebrow: 'Kesin kalkışlı turlarda standart butik hizmet seviyesi',
      heading: 'İnanç Tur’da VIP ve Butik Umre, Tanımlanmış Bir Hizmet Standardıdır',
      intro: 'Kesin kalkışlı gruplarımız 20–45 kişi arasında planlanır. Bu sezon Mekke’de tüm grup Fairmont’ta birlikte konaklar; Türk Hava Yolları, Medine–Mekke hızlı tren geçişi, VIP araçlar, yalnızca misafire odaklanan tur hocası, dört kişilik yerel saha ekibi ve sabah-akşam açık büfe hizmet modelinin parçalarıdır.',
    },
    ...buildDurationSeoEntries(season, 'tr'),
    ramadan: {
      title: `Ramazan Umre Turları ${season} | Tarih, Otel ve Fiyatlar`,
      h1: `${season} Ramazan Umre Turları`,
      description: `Ramazan umre turlarını; gidiş-dönüş tarihi, oruç günlerine uygun program, Mekke-Medine otelleri, oda tipi, uçuş ve kontenjana göre inceleyin.`,
      keywords: `${season} Ramazan umre turları, Ramazan umre fiyatları, Ramazan umresi tarihleri, son on gün umre`,
    },
    semester: {
      title: `Sömestr Umre Turları ${season} | Aile Programları`,
      h1: `${season} Sömestr Umre Turları`,
      description: `Sömestr tatiline uygun aile umre programlarını; kesin tarih, süre, otel, oda düzeni, çocuk fiyatı, uçuş ve kontenjana göre karşılaştırın.`,
      keywords: `${season} sömestr umre turları, yarıyıl tatili umre, aile umre programı, çocuklu aileler için umre`,
    },
    hotelGuide: {
      title: `Umre Otelleri Rehberi ${season} | Mekke ve Medine`,
      h1: 'Mekke ve Medine Umre Otelleri Seçim Rehberi',
      description: 'Umre otellerini; tam otel adı, Haremeyn mesafesi, ulaşım biçimi, yıldız sınıfı, yemek planı, oda düzeni ve gece sayısına göre karşılaştırın.',
      keywords: 'umre otelleri, Mekke umre otelleri, Medine umre otelleri, Kâbe’ye yakın oteller, Mescid-i Nebevi’ye yakın oteller',
    },
    deluxeGuide: {
      title: 'Delüks Umre Nedir? Lüks ve VIP Umre Farkları | İnanç Tur',
      h1: 'Delüks Umre Konsepti Nedir?',
      description: 'Delüks umrenin ne anlama geldiğini; 5 yıldızlı, lüks, VIP ve butik umreden farklarını, otel, transfer ve hizmet seçim ölçütlerini öğrenin.',
      keywords: 'delüks umre nedir, delüks umre konsepti, delüks ve lüks umre farkı, delüks ve VIP umre farkı, premium umre karşılaştırma',
    },
    selectionGuide: {
      title: 'Umre Turu Tavsiye Rehberi | En İyi Tur Nasıl Seçilir?',
      h1: 'Umre Turu Tavsiye ve Seçim Rehberi',
      description: 'Umre turu tavsiyesi arayanlar için otel mesafesi, acenta belgesi, uçuş, rehberlik, sözleşme, yorumlar ve fiyat şeffaflığına dayalı seçim rehberi.',
      keywords: 'umre turu tavsiye, umre turu tavsiyesi, en iyi umre turları, en iyi umre firmaları, güvenilir umre firması, umre firması nasıl seçilir, umre turu karşılaştırma',
    },
    femaleGuidance: {
      title: 'Umrede Kadın İrşad Görevlisi Var mı? | İnanç Tur',
      h1: 'Umre Turlarında Kadın İrşad Görevlisi Var mı?',
      description: 'İnanç Tur umrelerinde kadın irşad görevlisinin Ravza ziyareti, tur boyunca görevlendirme durumu ve kadınlara özel mobil uygulama desteği.',
      keywords: 'umrede kadın irşad görevlisi, kadın irşat görevlisi, umrede kadın hoca var mı, bayan hocalı umre turu, kadınlar için umre rehberi, Ravza kadın görevlisi',
    },
    trust: [
      { value: '21 yıl', label: 'Umre organizasyonu deneyimi' },
      { value: '3.500', label: 'Yıllık umre yolcusu' },
      { value: '40.000+', label: 'Bugüne kadar umre yolcusu' },
      { value: '7677', label: 'TÜRSAB belge numarası' },
    ],
  }
}
